import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import ServiceStructure from "../../components/Services/structure/ServiceStructure"

const DeliveryPartner = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Delivery Partner | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">
                  Request for being a Delivery partner to the GCF
                </h6>

                <ServiceStructure
                  disablePayableFee={true}
                  disableLicenseValidity={true}
                  detailsType="delivery-partner"
                  url="delivery-partner-apply"
                  serviceType="Request for being a Delivery partner to the GCF"
                  department="Advocacy & Multilateral Environment Agreement Monitoring Unit (AMEAMU)"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DeliveryPartner
